class Paypal {
  constructor(args) {
    const $this = this;
    $this.paypalLandingPage = '/paypal';
    $this.paypal = window.paypal;
    if (args) {
      Object.assign(this, args);
    }
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector;
    }
  }

  async createOrder() {
    const paypalLegacyReturnCancelUrl = 'https://www.paypal.com/checkoutnow/error';
    const { globals } = window
    const paypalParams = {
      cancelUrl: paypalLegacyReturnCancelUrl,
      returnUrl: paypalLegacyReturnCancelUrl,
    };
    return fetch(globals.paths.setPaypalExpressCheckout, {
      body: JSON.stringify(paypalParams),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }).then(res => res.json()).then(data => data.Data.Token);
  }

  onApprove(data, actions) {
    const { orderID, payerID } = data
    const { globals, jQuery, pageContextJavascript } = window;

    if ((pageContextJavascript !== null || pageContextJavascript !== undefined) && pageContextJavascript.showNewShippingBillingPage) {
      $.post(globals.paths.getPayPalExpressDetails, { token: orderID })
      .then(() => {
        window.location.href = `/Ordering/Checkout/Review?FeatureGate.NewShippingBillingPage=true&token=${orderID}&PayerID=${payerID}`;
      });
    } else {
      window.location.href = `/Ordering/Checkout/Review?token=${orderID}&PayerID=${payerID}`;
    }
  }

  onClick(data) {
    const page = window.digitalData.page.pageInfo.pageType;
    const pageVar = page === 'checkout' ? 'shipping' : page;
    const { fundingSource } = data;
    const isPayPalCredit = fundingSource === 'credit' || fundingSource === 'venmo';
    this.triggerAnalyticsEvent(pageVar, isPayPalCredit);
  }

  triggerAnalyticsEventBanners = (page, mktBannerId) => {
    window.ddoEventInit({
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'flex button',
        eventDescription: `paypal banner - ${page} page - ${mktBannerId.substr(1)}`,
      }
    });
  }

  triggerAnalyticsEvent = (page, isFinancing) => {
    if (isFinancing) {
      window.ddoEventInit({
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'flex button',
          eventDescription: `paypal credit - ${page} page`,
        }
      });
    } else {
      const pageVar = page === 'checkout' ? 'shipping' : page;
      window.ddoEventInit({
        category: {
          primaryCategory: 'button submission',
        },
        eventInfo: {
          eventName: `blinds paypal ${pageVar}`,
        },
      });
    }
  }

  watchClickOnMarketingBanners = mktBannerContainerSelector => {
    const $this = this;
    var mktBannersObj = {
      iframeMouseOver : false,
    };

    window.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (
          document.activeElement instanceof HTMLIFrameElement &&
          document.activeElement.closest(mktBannerContainerSelector)
        ) {
          const page = window.digitalData.page.pageInfo.pageType;
          $this.triggerAnalyticsEventBanners(page, mktBannerContainerSelector);
        }
      }, 0);
    });

    document.addEventListener('mouseover', (event) => {
      if (event.target.matches('[title="paypal_buttons"]')) {
        mktBannersObj.iframeMouseOver = true;
      }
    });

    document.addEventListener('mouseout', (event) => {
      if (event.target.matches('[title="paypal_buttons"]')) {
        mktBannersObj.iframeMouseOver = false;
      }
    });
  }

  getScript(url, callback) {
    const { jQuery } = window
    jQuery.ajax({
      cache: true,
      dataType: 'script',
      success: callback,
      type: 'GET',
      url,
    });
  }

  addHorizontalButtons(container, stylesParam) {
    const $this = this;
    const defaultStyles = {
      color: 'gold',
      fundingicons: false,
      height: 41,
      label: 'paypal',
      layout: 'horizontal',
      shape: 'rect',
      tagline: false,
    };
    const style = {...defaultStyles, ...stylesParam};
    if (typeof this.paypal !== 'undefined') {
      this.paypal.Buttons({
        createOrder: this.createOrder,
        onApprove: this.onApprove,
        onClick: (data) => {
          $this.onClick(data);
        },
        style,
      }).render(container);
    }
  }

  addVerticalButtons(container) {
    const $this = this;
    if (typeof this.paypal !== 'undefined') {
      this.paypal.Buttons({
        createOrder: this.createOrder,
        onApprove: this.onApprove,
        onClick: (data) => {
          $this.onClick(data);
        },
        style: {
          color: 'gold',
          fundingicons: false,
          label: 'paypal',
          layout: 'vertical',
          shape: 'rect',
          tagline: false,
        },
      }).render(container);
    }
  }

  addMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);
    if (container) {
      this.watchClickOnMarketingBanners(containerSelector);

      const { pageContextJavascript } = window;
      const defaultOptions = {
        account: pageContextJavascript.paypalAccountId,
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left',
          },
        },
      };
      // eslint-disable-next-line no-param-reassign
      options = options || {};
      this.getScript('https://www.paypalobjects.com/upstream/bizcomponents/js/messaging.js', () => {
        const { paypal } = window;
        paypal.Message.render({ ...defaultOptions, ...options }, containerSelector);
      });
    }
  }

  updateMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);
    if (container) {
      this.watchClickOnMarketingBanners(containerSelector);

      const { pageContextJavascript } = window;
      const defaultOptions = {
        account: pageContextJavascript.paypalAccountId,
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left',
          },
        },
      };
      const newOptions = options || {};
      const { paypal } = window;
      paypal.Message.render({ ...defaultOptions, ...newOptions }, containerSelector);
    }
  }
}

export default Paypal;
